<template>
  <div class="footerBox" :style="footerBackgroundImageStyle">
    <div class="footer_top">
      <div class="footer_logo">
        <img src="@/assets/Aboutart/footer_logo.png" alt="" />
      </div>
      <div class="footer_content">
        <div class="footer_tab">
          <div @click="linkJump(1, '/')">Homepage</div>
          <div @click="linkJump(1, '/Showcases')">Showcases</div>
          <div @click="linkJump(1, '/Accelerator')">GEC Initiative</div>
          <div @click="linkJump(1, '/Events')">Events</div>
          <div @click="linkJump(1, '/NewsInfo')">News & Info</div>
          <div @click="linkJump(1, '/Connections')">Connections</div>
          <div @click="linkJump(1, '/AboutUs')">About us</div>
        </div>
        <div class="footer_hema">
          <div class="footer_hema_title">Contact us</div>
          <div class="footer_hema_content">
            <div>
              For any further questions or information,
            </div>
            <div>
              please feel free to contact us:
            </div>
            <div>
              gec_team@163.com
            </div>
          </div>
        </div>
      </div>
      <div @click="handleGov" style="cursor: pointer" class="footer_copyright">
        Copyright © 2012-2022 AABI. All right reserved 沪ICP备10000351号-8
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
// import VueQr from "vue-qr";
export default {
  components: {},
  data() {
    return {
      navStatus: null,
      screenWidth: null,
    };
  },
  computed: {
    footerBackgroundImageStyle() {
      if (this.screenWidth >= 1024) {
        return {
          backgroundImage: `url(${require("@/assets/footer/footer-Rectangle.png")})`,
        };
      } else {
        return {
          backgroundImage: `url(${require("@/assets/footer/Mfooter-Rectangle.png")})`,
        };
      }
    },
  },

  methods: {
    handleGov() {
      window.open("https://beian.miit.gov.cn/");
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
</style>
<style lang="less" scoped>
@media screen and (min-width: 750px) {
  @import "./indexPC.less";
}
@media screen and (max-width: 750px) {
  @import "./indexM.less";
}
</style>
